module.exports = __webpack_public_path__ + "img/real-madrid.f04c74af.png";